import { Pipe, PipeTransform } from '@angular/core';
import { ExerciseRendererService } from './exercise-renderer.service';
import { AlgoliaSdkType } from 'src/app/services/algolia.service';

/**
 * Takes in an exerciseId, and returns an Exercise from algolia
 */
@Pipe({
  name: 'exerciseRenderer',
  pure: true
})
export class ExerciseRendererPipe implements PipeTransform {
  constructor(private $exerciseRenderer: ExerciseRendererService) {}

  transform(exerciseId: string, algoliaSdkType: AlgoliaSdkType) {
    return this.$exerciseRenderer.getExerciseById(exerciseId, algoliaSdkType);
  }

}
